import { RootState } from 'app/store';

export const selectAppLoading = (state: RootState) => state.app.loading;
export const selectCountries = (state: RootState) => state.app.countries;
export const selectCities = (state: RootState) => state.app.cities;
